export enum ReportType {
  KPI_COMPARE_REPORT = 'KPI_COMPARE_REPORT',
  KPI_DETAIL_REPORT = 'KPI_DETAIL_REPORT',
  STATUS_MAP_REPORT = 'STATUS_MAP_REPORT',
  OEE_KPI_REPORT = 'OEE_KPI_REPORT',
  ALARM_LEVEL_REPORT = 'ALARM_LEVEL_REPORT',
  ALARM_TYPE_REPORT = 'ALARM_TYPE_REPORT',
  PLANT_ASSET_MONITORING = 'PLANT_ASSET_MONITORING',
}
